// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonGoForward_button__2Oct0","imgClass":"ButtonGoForward_imgClass__13OTO"};